import * as React from 'react';

import { Link, Typography, Typography2 } from '@coursera/cds-core';
import { ArrowNextIcon } from '@coursera/cds-icons';
import type { SectionName, UpsellType } from '@coursera/event-pulse-types';
import { useTracker, useVisibilityTracker } from '@coursera/event-pulse/react';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import UpsellCard from 'bundles/unified-description-page-common/components/modules/upsell/UpsellCard';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';

import upsellModuleAdvanceCareer from 'images/unified-description-page/upsell-module-advance-career.png';

import _t from 'i18n!nls/xdp';

type Props = {
  // This will be added dynamically from UpsellModule.
  amountOfCards?: number;
};

const DegreeUpsellCard = ({ amountOfCards }: Props) => {
  const track = useTracker();
  const eventingProductData = useEventingProductData();
  const trackingData = {
    upsellType: 'degree' as UpsellType,
    pageSection: {
      sectionName: 'upsell' as SectionName,
    },
    ...eventingProductData,
  };

  const visibilityTrackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_upsell_card',
    trackingData
  );

  return (
    <UpsellCard
      title={
        <Typography color="invertBody" variant="h1semibold" component="h2">
          {_t('Advance your career with an online degree')}
        </Typography>
      }
      description={
        <Typography2 color="invertBody" variant="bodySecondary" component="p">
          {_t('Earn a degree from world-class universities - 100% online')}
        </Typography2>
      }
      cta={
        <Link
          component={TrackedA}
          href="/degrees"
          trackingName="upsell_cta_degrees"
          typographyVariant="subtitleMedium"
          variant="quiet"
          invert
          icon={<ArrowNextIcon />}
          onClick={() => {
            track('click_upsell_card', trackingData);
          }}
        >
          {_t('Explore degrees')}
        </Link>
      }
      backgroundImage={upsellModuleAdvanceCareer}
      backgroundPosition="30%"
      amountOfCards={amountOfCards}
      ref={visibilityTrackingRef}
    />
  );
};

export default DegreeUpsellCard;
